const localizers = {
  'loading.msg': () => `Loading...`,
  'SASServer.genericError.msg': () => `The server cannot be reached.`,
  'SASReport.genericError.msg': () => `Unable to load the selected report.`,
  'SASReportImage.genericError.msg': () => `The report image failed to load.`,
  'SASReportImage.imageNotSupported.msg': () => `Images are not supported for this report content type.`,
}
export default localizers;
